<template>
  <div class="czewm-box">
    <div class="czewm-content" v-if="data">
      <canvas ref="qrcodeCanvas" class="czewm-qrcode"></canvas>
      <span class="czewm-label">{{data.networkName}} {{$t('all.chongbidizhi')}}</span>
      <div class="czewm-address">
        <span class="czewm-address-text">{{data.address}}</span>
		<img class="czewm-address-copy" src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="handleCopy"/>
      </div>
      <div class="czewm-status" v-if="rechargeStatus">
        <span :class="rechargeStatus === 'success' ? 'czewm-status-success' : 'czewm-status-pending'">
          {{rechargeStatus === 'success' ? $t('all.chongzhichenggong') : $t('all.dengdaiquerenzhong')}}
        </span>
      </div>
      <div class="czewm-btn-gradient" @click="handleSaveQr">{{$t('all.baocunerweima')}}</div>
      <div class="czewm-btn" @click="handleCopy">{{$t('all.fuzhidizhi')}}</div>
    </div>
  </div>
</template>

<script>
import { toRecharge, getRechargeStatusInfo } from "@/api/qianbao";
import QRCode from 'qrcode';
export default {
  data() {
    return {
  	  data: '',
      rechargeStatus: '',
      pollTimer: null
    };
  },
  mounted() {
  	this.toRecharge()
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  },
  methods: {
	async toRecharge(){
	  const res = await toRecharge({
		amount: this.$route.query.amount,
		blockchainNetworkConfigId: this.$route.query.blockchainNetworkConfigId, 
	  })
	  this.data = res.data
	  // 生成二维码
	  this.$nextTick(() => {
	    this.generateQrCode();
	  });
	  // 开始轮询充值状态
	  //this.startPolling();
	},
	generateQrCode() {
	  const canvas = this.$refs.qrcodeCanvas;
	  if (!canvas || !this.data.address) return;
	  QRCode.toCanvas(canvas, this.data.address, {
	    width: 200,
	    margin: 2,
	    color: {
	      dark: '#000000',
	      light: '#ffffff'
	    }
	  }, (error) => {
	    if (error) {
	      console.error('生成二维码失败:', error);
	    }
	  });
	},
	startPolling() {
	  if (this.pollTimer) clearInterval(this.pollTimer);
	  this.pollTimer = setInterval(() => {
	    this.checkRechargeStatus();
	  }, 2000);
	},
	async checkRechargeStatus() {
	  if (!this.data || !this.data.rechargeId) return;
	  try {
	    const res = await getRechargeStatusInfo({ rechargeId: this.data.rechargeId });
	    const status = res.data && res.data.status;
	    if (status === 1 || status === 'success') {
	      this.rechargeStatus = 'success';
	      clearInterval(this.pollTimer);
	      this.pollTimer = null;
	      this.$message.success(this.$t('all.chongzhichenggong'));
	      setTimeout(() => {
	        this.$router.push('/chongzhichenggong');
	      }, 1500);
	    } else if (status === 0 || status === 'pending') {
	      this.rechargeStatus = 'pending';
	    }
	  } catch (error) {
	    console.error('查询充值状态失败:', error);
	  }
	},
    handleSaveQr() {
      const canvas = this.$refs.qrcodeCanvas;
      if (!canvas) return;
      const link = document.createElement('a');
      link.download = 'recharge_qrcode.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
      this.$message.success(this.$t('all.baocunchenggong') || '保存成功');
    },
    handleCopy() {
      if (this.data && this.data.address) {
        navigator.clipboard.writeText(this.data.address);
        this.$message.success(this.$t('all.fuzhichenggong'));
      }
    }
  }
};
</script>

<style scoped lang="scss">
.czewm-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 130px);
  padding: 0 20px;
}

.czewm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  width: 100%;
}

.czewm-qrcode {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 8px;
}

.czewm-label {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 10px;
}

.czewm-address {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.czewm-address-text {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #369AFF;
  word-break: break-all;
  text-align: center;
}

.czewm-address-copy {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

.czewm-status {
  margin-bottom: 20px;
}

.czewm-status-success {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #00D68F;
}

.czewm-status-pending {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 14px;
  color: #FF9F43;
}

.czewm-btn-gradient {
  width: 300px;
  height: 48px;
  background: linear-gradient( 90deg, #6BEEFE 0%, #0595F3 34.95%, #7300DF 67.82%, #9A00A8 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
  margin-bottom: 12px;
}
.czewm-btn-gradient:hover {
  opacity: 0.9;
}

.czewm-btn {
  width: 300px;
  height: 48px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  cursor: pointer;
}
.czewm-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}
</style>



// WEBPACK FOOTER //
// chongzhierweima.vue?c1635798